import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AzureLoginService } from 'src/app/services/azure-login.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ApiConstants } from '../modules/crm/shared/constants/api.constant';

export interface AzureMapsAddress {
  address1?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  suggestedFullAddress?: string;
  latitude: number;
  longitude: number;
}

interface AzureMapsEnvelope {
  statusCode: number;
  errorMessage?: string;
  body: AzureMapsAddress | Record<string, never> | null;
}

@Injectable({
  providedIn: 'root',
})
export class AzureMapsService {
  public selectedValue = [];
  constructor(
    private http: HttpClient,
    private azureService: AzureLoginService,
  ) {}

  getAddressDetails(address: string): Observable<AzureMapsAddress> {
    const headers = {
      'content-type': 'application/json',
      Authorization: `Bearer ${this.azureService.accessToken}`,
    };
    const payload = {
      query: address,
    };
    return this.http
      .post<AzureMapsEnvelope>(
        `${environment.baseScmApiUrl}/${ApiConstants.azureMapsUrl}`,
        JSON.stringify(payload),
        { headers },
      )
      .pipe(map((envelope) => this.toAddress(envelope)));
  }

  private toAddress(envelope: AzureMapsEnvelope): AzureMapsAddress {
    const body = envelope?.body;
    const hasCoordinates =
      body != null &&
      typeof body === 'object' &&
      typeof (body as AzureMapsAddress).latitude === 'number' &&
      typeof (body as AzureMapsAddress).longitude === 'number';

    if (envelope?.statusCode === 200 && hasCoordinates) {
      return body as AzureMapsAddress;
    }

    throw new Error(envelope?.errorMessage || 'Azure Maps lookup failed');
  }
}
